const getters = {
  showphysicianvisiable: state => state.app.showphysicianvisiable, // 控制视频控件的显示隐藏
  userId: state => state.app.userId, // 用户ID
  appId: state => state.app.appId, // 视频应用的APPID
  roomNumber: state => state.app.roomNumber, // 发起视频后的房间号
  inquiryRecordGuid: state => state.app.inquiryRecordGuid, // 问诊记录guid
  userSign: state => state.app.userSign, // 视频应用的密钥
  patientGuid: state => state.app.patientGuid, // 患者guid
  socketStatus: state => state.app.socketStatus //socket状态
}
export default getters
